









































import {Component, Prop, Watch} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import AsiSelectSimple from "@/components/common/AsiSelectSimple";
import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import AsiListTableHeader from "@/components/common/AsiListTableHeader";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import PaginatedResponse from "@/models/PaginatedResponse";
import AsiListTable from "@/components/common/AsiListTable.vue";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import UserSimple from "@/models/user/UserSimple";
import AsiCheckbox from "@/components/common/AsiCheckbox";
import OrderAutocompleteInput from "@/components/order/OrderAutocompleteInput.vue";
import UserAutocompleteInput from "@/components/user/UserAutocompleteInput.vue";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {
		UserAutocompleteInput,
		OrderAutocompleteInput,
		AsiCheckbox,
		AsiDatePicker,
		AsiTextFieldSimple, AsiSelectSimple, AsiAvatar, AsiContentContainer, AsiListTableLayout
	}
})
export default class PlanningEntryList extends AsiListTable<PlanningEntryListEntry, PlanningEntryListFilter> implements IAsiListTableImplementation<PlanningEntryListEntry, PlanningEntryListFilter> {

	@Prop({type: Object, default: null})
	public planningEntryFilterModel!: PlanningEntryListFilter | null;

	@Prop({type: Object, default: null})
	public user!: UserSimple | null;

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;

	private icons = Icon;
	private booleanItems = [
		{value: true, text: this.$t('ui.yes')},
		{value: false, text: this.$t('ui.no')},
	];

	public constructor() {
		super();
		this.filterModel = this.createFilterModel();
	}

	public mounted(): void {
		this.tableOptions.sortBy = ['date'];
		this.tableOptions.sortDesc = [true];
		this.reload();
	}

	private get dateRange(): string[] | null {
		if (this.filterModel === null) return null;
		const ret = [];
		if (this.filterModel.dateFrom !== null) ret.push(this.filterModel.dateFrom);
		if (this.filterModel.dateTo !== null) ret.push(this.filterModel.dateTo);
		return ret;
	}

	private set dateRange(value: string[] | null) {
		if (this.filterModel === null) return;
		this.filterModel.dateFrom = value === null ? null : (value[0] ?? null);
		this.filterModel.dateTo = value === null ? null : (value[1] ?? null);
	}

	public createFilterModel(): PlanningEntryListFilter {
		const filter = this.planningEntryFilterModel ?? new PlanningEntryListFilter();
		if (this.user) {
			filter.userId = this.user.id;
		}
		return filter;
	}

	public createHeaders(): AsiListTableHeader[] {
		const ret = [
			new AsiListTableHeader('', 'avatar', false, false, 'center', '4rem'),
			new AsiListTableHeader(this.$t('company.singular').toString(), 'order.company.name', true, true, 'start', '20%'),
			new AsiListTableHeader(this.$t('order.singular').toString(), 'order.name', true, true, 'start'),
			new AsiListTableHeader(this.$t('planningEntry.date').toString(), 'date', true, true, 'center', '10rem'),
		];

		if (!this.user) {
			ret.push(new AsiListTableHeader(this.$t('user.fullName').toString(), 'fullName', false, false, 'start', '20%'));
		}

		return ret;
	}

	public fetchData(filterModel: PlanningEntryListFilter | null, tableOptions: AsiListTableOptions | null): Promise<PaginatedResponse<PlanningEntryListEntry>> {
		return this.$planningEntryService.planningEntries(filterModel, tableOptions);
	}

	public filterTextChanged(filterText: string): void {
		if (this.filterModel === null) return;
		this.filterModel.fulltext = filterText;
	}

	public openModelDetailPage(): void {
		return;
	}

	public reload(goToFirstPage: boolean = false): void {
		this.reloadInternal(this, goToFirstPage);
	}

	public userFullName(user: UserSimple | null): string | null {
		return UserSimple.fullName(user);
	}

	protected avatarUrl(companySimple: CompanySimple): string | null {
		return CompanySimple.avatarUrlMedium(companySimple);
	}

	@Watch('tableOptions', {deep: true})
	private onTableOptionsChanged(): void {
		this.reload();
	}

	@Watch('filterModel', {deep: true})
	private onFilterModelChanged(): void {
		this.reload(true);
	}

}
